/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */

export interface UserSettingRequest {
    locale: string;
    time_format: string;
    selectedCRMId?: string;
}

export enum TimeFormat {
    TWELVE_HOUR = '12H',
    TWENTY_FOUR_HOUR = '24H',
}

export interface UserSettings {
    locale: string;
    selectedLocal: string;
    timeFormat: TimeFormat;
    selectedTimeFormat: TimeFormat;
    isValid: boolean;
    crmId?: string;
    selectedCRMId?: string;
}

export interface UserInfo {
    sub: string;
    time_format?: string;
    app_tid: string;
    mail: string;
    iss: string;
    groups: string[];
    given_name: string;
    locale?: string;
    nonce: string;
    sid: string;
    aud: string;
    scim_id: string;
    user_uuid: string;
    crm_account_id: string;
    zone_uuid: string;
    company: string;
    exp: number;
    iat: number;
    family_name: string;
    jti: string;
}

export interface UserLocalStorage extends UserInfo {}

export interface ControlTypeContent {
    id: string;
    name: string;
    orientation: string;
    controlTypeOptions: ControlTypeOption[];
}

export interface ControlTypeOption {
    id: string;
    controlTypeId: string;
    value: string;
    displayOrder: number;
    translationValueKey: string;
}

export interface PhaseState {
    id: string;
    name: string;
    translationNameKey: string;
    flowId: string;
    displayOrder: number;
    phaseName: string;
}

export interface ITask {
    id: string;
    contentTypeId: string | null;
    step: IStep;
    phase: IPhase;
    flow: IFlow;
    title: string;
    helpLink: string;
    description: string;
    productConfigurationKey: string | null;
    defaultValue: string | null;
    mandatory: boolean;
    displayOrder: number;
    controlType: IControlType;
    videoHelpLink: string;
    iconLink: string;
    translationTitleKey: string;
    translationNameKey: string | null;
    name: string | null;
}

export interface IStep {
    id: string;
    name: string;
    title: string;
    description: string;
    displayOrder: number;
    translationNameKey: string;
    translationTitleKey: string;
    stepName: string;
    phaseId: string;
    answered: boolean;
}

export interface IPhase {
    id: string;
    flowId: string;
    name: string;
    displayOrder: number;
    translationNameKey: string;
}

export interface IFlow {
    id: string;
    name: string;
    productId: string;
    active: boolean;
}

export interface IControlType {
    id: string;
    name: string;
    orientation: string;
    controlTypeOptions: unknown[];
}

export interface ITaskData {
    values: Record<string, any>;
    tasks: ITask[];
}

export interface IStyle {
    style?: React.CSSProperties;
}

export type PersonalizationStatus = 'not-started' | 'in-progress' | 'success' | 'failed';
